import React from "react";
import logo from "src/assets/logos/cloudoor-02.png";
import logo_collapsed from "src/assets/logos/cloudoor-04.png";
import logout from "src/assets/icons/logout.svg";
import gateway from "src/assets/icons/api-solid.svg";
import domain from "src/assets/icons/stash_domain.svg";
import authserver from "src/assets/icons/lock.svg";
import endpoint from "src/assets/icons/icon-park-solid_endpoint-displacement.svg";
import { userInfoService } from "src/services/userInfo";
import { ConfigType } from "src/types";
import { OrganizationService } from "src/services/organization";
import Autocomplete from "src/components/searchSelect"
import { AppContext } from "src/contexts";
import { jwtDecode } from "jwt-decode";

export default function SideBar() {
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [currentPath, setCurrentPath] = React.useState(window.location.hash?.replace("#", ""));
  const { token, setOrganizations, organizations, organizationId } = React.useContext(AppContext); 
  const [currentRole, setCurrentRole] = React.useState<string>("");

     const isTokenValid = (token: string) => {
       if (!token) return false; // Aucun token

       try {
         const decoded = jwtDecode(token);
         const currentTime = Date.now() / 1000; // Convertir en secondes
         return decoded?.exp && decoded?.exp > currentTime; // Comparer la date d'expiration
        } catch (error) {
          return false; // Erreur de décodage = Token invalide
        }
  };
  
  const getOrganizations = async () => {
    const token = localStorage.getItem("token");
    setTimeout( async() => {
      if (token && isTokenValid(token)) {
        await OrganizationService.getOrganizations().then((response) => {
           setOrganizations(
            [...response]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((item: ConfigType) => ({
              label: item.name,
              value: item.id,
            }))
          );
          getUserInfo()
        })
      } 

    },1000)
  }
  const getPrivilegeByOrganizationId = (
    permissions: any[],
    contextOrganizationId: string
  ) => {
    const matchingPermission = permissions.find(
      (permission) => permission.organizationId === contextOrganizationId
    );

    return matchingPermission ? matchingPermission.privilege : null;
  };
  const getUserInfo = async () => {
    await userInfoService.getUsersInfos().then((response) => {
    const privilege = getPrivilegeByOrganizationId(
      response.roles,
      organizationId
    );
    setCurrentRole(privilege);
    });
  }
  React.useEffect(() => {
    getOrganizations();
    const handleLocationChange = () => {
      setCurrentPath(window.location.hash?.replace("#", ""));
    };
    window.addEventListener("popstate", handleLocationChange);
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    userInfoService.logout();
  };

  return (
    <div className={`bg-[#ebf0f3] flex flex-col p-[2rem] transition-all duration-400 w-auto relative ${isCollapsed ? "items-center" : "items-start"}`}>
      <button
        onClick={toggleCollapse}
        className="absolute -right-4 top-12 bg-[#ebf0f3] rounded-full p-1.5 border border-gray-200 cursor-pointer h-10 w-10"
      >
        {isCollapsed ? (
          <i className="bi bi-chevron-right"></i>
        ) : (
          <i className="bi bi-chevron-left"></i>
        )}
      </button>
      {!isCollapsed ? (
        <SimpleSideBar
          currentPath={currentPath}
          handleLogout={handleLogout}
          options={organizations}
          currentRole={currentRole}
        />
      ) : (
        <SideBarCollapsed
          currentPath={currentPath}
          handleLogout={handleLogout}
          currentRole={currentRole}
        />
      )}
    </div>
  );
}

const SimpleSideBar = ({currentPath, handleLogout, options, currentRole}: {currentPath: string, handleLogout: () => void, options: any[], currentRole: string}) => {
  const [currentOrg, setCurrentOrg] = React.useState<any>(null);
  const id = localStorage.getItem("organizationId");
  const { email } = React.useContext(AppContext);

  React.useEffect(() => {
    if(id){
      const item = options?.find((item) => item?.value === id)
      if (item) {
        localStorage.setItem("organizationName", item?.label)
        setCurrentOrg(item)  
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id,options])
  const handleOrgChange = (event: any, value: any) => {
    if (value !== null) {
      setCurrentOrg(value)
      localStorage.setItem('organizationId', value.value);
      window.location.href = "/#/endpoints";
      window.location.reload();
    }
  };
  return (
    <>
      <div className="flex flex-col items-center p-2 justify-center mb-2 w-full">
        <img src={logo} alt="" className="pb-2 cursor-pointer w-[6rem]" />

        <p className="text-[10px] text-[#475367]">{email}</p>


      </div>
        <Autocomplete
          fullWidth
          name="org"
          options={options}
          onChange={handleOrgChange}
          value={currentOrg || ""}
        />
      <hr className="w-full my-1 text-[#545557]" />
      <a
        href="/#/endpoints"
        className={`flex flex-row justify-center my-2 
        ${
          currentPath === "/endpoints" || currentPath.includes("/endpoints")
            ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-[2.5rem] rounded"
            : ""
        }`}
      >
        <div className="mr-2 w-[1.75rem] items-center flex justify-center">
          <img src={endpoint} alt="" />
        </div>
        <p>Endpoints</p>
      </a>
      <a
        href="/#/authservers"
        className={`flex flex-row justify-center my-2 
        ${
          currentPath === "/authservers" || currentPath.includes("/authservers")
            ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-[2.5rem] rounded"
            : ""
        }`}
      >
        <div className="mr-2 w-[1.75rem] items-center flex justify-center">
          <img src={authserver} alt="Authserver" />
        </div>
        <p>Authserver</p>
      </a>
      {currentRole !== "developer" && (
        <a
          href="/#/domains"
          className={`flex flex-row justify-center my-2 
        ${
          currentPath === "/domains" || currentPath.includes("/domains")
            ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-[2.5rem] rounded"
            : ""
        }`}
        >
          <div className="mr-2 w-[1.75rem] items-center flex justify-center">
            <img src={domain} alt="" />
          </div>
          <p>Domains</p>
        </a>
      )}
      <a
        href="/#/gateways"
        className={`flex flex-row justify-center my-2 
        ${
          currentPath === "/gateways" || currentPath.includes("/gateways")
            ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-[2.5rem] rounded"
            : ""
        }`}
      >
        <div className="mr-2 w-[1.75rem] items-center flex justify-center">
          <img src={gateway} alt="" />
        </div>
        <p>Gateways</p>
      </a>

      <div className="mt-auto w-full">
        <button
          onClick={handleLogout}
          className="flex flex-row items-stretch justify-center px-4 py-2 mt-2 text-red-600 hover:bg-red-100 rounded-md"
        >
          <img src={logout} alt="" className="w-[1.5rem] pb-2" />
          Logout
        </button>
      </div>            
    </>
  );
}

const SideBarCollapsed = ({currentPath, handleLogout, currentRole}: {currentPath: string, handleLogout: () => void, currentRole: string}) => {
  return (
    <>
    <div className="flex flex-col !items-center p-2">
        <img
          src={logo_collapsed}
          alt=""
          className="pb-2 cursor-pointer w-[3rem]"
        />

      </div>
      <hr className="w-full my-1 text-[#545557]" />
      <a href="/#/endpoints" className={`flex flex-row justify-center my-2 
        ${
          (currentPath === "/endpoints" || currentPath.includes("/endpoints")) ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-1 rounded" : ""
        }`
        }>
        <div className="w-[1.75rem] items-center flex justify-center">
          <img src={endpoint} alt="" />
        </div>
      </a>
      <a href="/#/authservers" className={`flex flex-row justify-center my-2 
        ${
          (currentPath === "/authservers" || currentPath.includes("/authservers")) ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-1 rounded" : ""
        }`
        }>
        <div className="w-[1.75rem] items-center flex justify-center">
          <img src={authserver} alt="" />
        </div>
      </a>

      {currentRole !== "developer" && (
        <a
          href="/#/domains"
          className={`flex flex-row justify-center my-2 
        ${
          currentPath === "/domains" || currentPath.includes("/domains")
            ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-1 rounded"
            : ""
        }`}
        >
          <div className="w-[1.75rem] items-center flex justify-center">
            <img src={domain} alt="" />
          </div>
        </a>
      )}
      <a
        href="/#/gateways"
        className={`flex flex-row justify-center my-2 
        ${
          (currentPath === "/gateways" || currentPath.includes("/gateways")) ? "shadow-[0_0_10px_rgba(0,0,0,0.1)] bg-[#FFF] py-2 pl-1 pr-1 rounded" : ""
        }`
        }>
        <div className="w-[1.75rem] items-center flex justify-center">
          <img src={gateway} alt="" />
        </div>
      </a>
      <div className="mt-auto">
        <button
          onClick={handleLogout}
          className="flex justify-center px-4 py-2 mt-2 text-red-600 hover:bg-red-100 rounded-md"
        >
          <img src={logout} alt="" className="w-[1.8rem] pb-2" />
        </button>
      </div>
    </>
  );
};
